import React, { useEffect, useState } from 'react';
import styles from './popup.module.css';
import notice from '~/static/images/notice.png';

export function PopupContainer() {
  const [popup, setPopup] = useState(false);

  useEffect(() => {
    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const lastViewedDate = localStorage.getItem('last_viewed_date');

    if (lastViewedDate !== today) {
      localStorage.setItem('last_viewed_date', today);
      setPopup(true);
    }
  }, []);

  return popup ? (
    <div className={styles.popup}>
      <div onClick={() => {
        setPopup(false);
      }} className={styles.popupOverlay} />

      <div className={styles.popupContent}>
        <img src={notice} alt="" />
        
        <button className={styles.popupClose} onClick={() => {
          setPopup(false);
        }} title="Fechar">x</button>
      </div>
    </div>
  ) : null
}
